<div>
    <p style=" margin-top: -4px;">
        {{languageData['customersLiveTracking'].VarPageCustomerTracking4 || 'Weitere Details zu dieser Lieferung werden
        erst nach Angabe des korrekten Vor- und Nachnamens freigegeben.'}}
    </p>
    <!-- [ngStyle]="{background: colors.Grundfarbe,color: colors.Schriftfarbe_Buttons}" -->
    <button class="dynamicColors"
        (click)="closePopup()"> {{languageData['customersLiveTracking'].VarConfirm || 'Bestätigen'}}
    </button>
</div>